import { render, staticRenderFns } from "./financeiro-tabela-feriados.vue?vue&type=template&id=835dffdc&scoped=true"
import script from "./financeiro-tabela-feriados.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-feriados.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-feriados.vue?vue&type=style&index=0&id=835dffdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835dffdc",
  null
  
)

export default component.exports